import { render, staticRenderFns } from "./PaymentLoader.vue?vue&type=template&id=98ef367c&scoped=true&"
import script from "./PaymentLoader.vue?vue&type=script&lang=js&"
export * from "./PaymentLoader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLoader.vue?vue&type=style&index=0&id=98ef367c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef367c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
